import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { RiskMatrixCell, RiskMatrixDetailsWire } from 'app/area/risk-matrix-administration/types-store';
import { ComplexValue } from 'ui';
import { CodeListWire } from 'app/area/codetable/common';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { CaseTypeWire, RiskMatrixCellsResponse } from 'app/area/risk-matrix-administration/types';

export const api = {
  loadDetails: async (type: ComplexValue<number>): Promise<RiskMatrixDetailsWire> => {
    const response = await new RemoteAdminData(endpoints.details(type.value))
      .resource<ApiResponse<RiskMatrixDetailsWire>>()
      .filter({ 'api-version': '3.0' })
      .single();

    return response.data;
  },

  loadCaseTypes: async (type: ComplexValue<number>): Promise<CaseTypeWire[]> => {
    const response = await new RemoteAdminData(endpoints.caseTypes(type.value))
      .resource<ApiResponse<CaseTypeWire[]>>()
      .single();

    return response.data;
  },

  loadAxis: async (axis: number): Promise<CodeListWire> => {
    const response = await new RemoteAdminData(endpoints.axis(axis))
      .resource<Response>()
      .filter({ 'api-version': '3.0' })
      .create({ limitFieldsTo: [CodeFieldWireKey.code] });

    const json = await response.json();

    return json.data;
  },

  loadRiskAreas: async (): Promise<CodeListWire> => {
    const response = await new RemoteAdminData(endpoints.riskAreas())
      .resource<Response>()
      .filter({ 'api-version': '3.0', displayNotSelected: true })
      .create({});

    const json = await response.json();

    return json.data;
  },

  loadCells: async (type: ComplexValue<number>): Promise<RiskMatrixCellsResponse> => {
    const response = await new RemoteAdminData(endpoints.cells(type.value))
      .resource<ApiResponse<RiskMatrixCellsResponse>>()
      .single();

    return response.data;
  },

  saveCells: async (cells: RiskMatrixCell[]): Promise<RiskMatrixCell[]> => {
    const response = await new RemoteAdminData(endpoints.update())
      .resource<ApiResponse<RiskMatrixCell[]>>()
      .update(cells);

    return response.data;
  }
};
